import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SectionTitle from "../common/SectionTitle";
import QuarriesCard from "./QuarriesCard";

function QuarriesBalikesirWhiteRiver() {
  const { t } = useTranslation();

  return (
    <section className="p-5 text-center ocaklarimiz" id="balikesirwhiteriver">
      <div className="container" style={{ marginTop: "5rem" }}>
        <SectionTitle title={t("BALIKESİR WHİTE RİVER")} />
      </div>

      <div className="row row-cols-1 row-cols-md-3 g-4">
        <div className="col mb-4">
          <QuarriesCard
            link="/whiteriver"
            title={t("White River")}
            picture="/assets/img/White-River.webp"
            company="Sürkay Madencilik Ltd. Şti."
          />
        </div>
      </div>
    </section>
  );
}

export default QuarriesBalikesirWhiteRiver;